<template>
  <div class="Product">
    <div class="content">
      <img src="../assets/SoftwareComparison/banner.png" class="img-fluid" alt="Responsive image" />
      <div class="content-detail">
        <h1 data-delighter class="left">印点点自助打印系统这么多</h1>
        <h1 data-delighter class="left">我该怎么选？</h1>
      </div>
    </div>

    <div class="section-wrap">
      <div class="container">
        <h2 class="title">产品对比</h2>
        <!-- <p class="secd">再好的方案只有适合自己的，才是最好的！</p>
        <p class="secd">考虑到广大商家及企业的不同场景需要，</p>
        <p class="secd">我们推出三种方案可供选择，真正做到量身定制，契合匹配</p> -->
      </div>

      <div class="container comparison-table">
        <!-- ----------- comp-wrap START ----------- -->
        <div class="comp-wrap">
          <!-- 左侧导航 -->
          <aside class="sidebar">
            <div style="text-align: left;padding: 10px 12px;font-size: 16px;font-weight: bold;">目录</div>
            <a v-for="id in sectionIds" :key="id" :href="'#' + id" :class="{ active: activeId === id }" @click.prevent="scrollTo(id)">
              {{ labels[id] }}
            </a>
          </aside>

          <div>
            <!-- 右侧对比主体 -->
            <main class="compare">
              <div class="grid tit-head" style="position: sticky; top: 0; background: #fff; z-index: 999;box-sizing: border-box;">
                <div class="cell cell-head">功能服务</div>
                <div class="cell cell-head">自助打印软件</div>
                <div class="cell cell-head">图文店自助打印软件</div>
                <div class="cell cell-head">复印机自助打印</div>
                <div class="cell cell-head">共享打印软件</div>
              </div>
              <!-- ============ 主要功能 ============ -->
              <section id="main" class="block">
                <div class="block-title grid">
                  <div class="cell label">主要功能</div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                </div>
                <div class="grid">

                  <div class="cell label">打印</div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>

                  <div class="cell label">复印</div>
                  <div class="cell center">手机拍照复印</div>
                  <div class="cell center">手机拍照复印</div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" />（复印机原生）</div>
                  <div class="cell center">手机拍照复印</div>

                  <div class="cell label">扫描</div>
                  <div class="cell center">手机拍照</div>
                  <div class="cell center">手机拍照</div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" />（复印机原生）</div>
                  <div class="cell center">手机拍照</div>

                  <div class="cell label">照片</div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>

                  <div class="cell label">证件照</div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>

                  <div class="cell label">电脑自助打印</div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>

                  <div class="cell label">手机自助打印</div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>

                  <div class="cell label">远程打印</div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>
                </div>
              </section>

              <!-- ============ 支持机型 ============ -->
              <section id="model" class="block">
                <div class="block-title grid">
                  <div class="cell label">支持机型</div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                </div>
                <div class="grid">

                  <div class="cell label">品牌</div>
                  <div class="cell center">不限</div>
                  <div class="cell center">不限</div>
                  <div class="cell center">柯美 / 爱普生 / 富士施乐</div>
                  <div class="cell center">不限</div>

                  <div class="cell label">型号</div>
                  <div class="cell center">不限</div>
                  <div class="cell center">不限</div>
                  <div class="cell center">指定型号</div>
                  <div class="cell center">不限</div>
                </div>
              </section>

              <!-- ============ 安装运行 ============ -->
              <section id="install" class="block">
                <div class="block-title grid">
                  <div class="cell label">安装运行</div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                </div>
                <div class="grid">

                  <div class="cell label">初次安装</div>
                  <div class="cell center">电脑/盒子</div>
                  <div class="cell center">电脑</div>
                  <div class="cell center">借助电脑嵌入到复印机</div>
                  <div class="cell center">有网即可</div>

                  <div class="cell label">运行环境</div>
                  <div class="cell center">电脑/盒子</div>
                  <div class="cell center">电脑</div>
                  <div class="cell center">有网即可</div>
                  <div class="cell center">有网即可</div>
                </div>
              </section>

              <!-- ============ 应用场景 ============ -->
              <section id="scene" class="block">
                <div class="block-title grid">
                  <div class="cell label">应用场景</div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                </div>
                <div class="grid">

                  <div class="cell label">常见场景</div>
                  <div class="cell center">图文店 / 广告店 / DIY自助打印机</div>
                  <div class="cell center">图文店 / 广告店</div>
                  <div class="cell center">高校 / 政务大厅 / DIY自助复印机</div>
                  <div class="cell center">门店 / 驿站 / 共享打印机</div>
                </div>
              </section>

              <!-- ============ 市场情况 ============ -->
              <section id="market" class="block">
                <div class="block-title grid">
                  <div class="cell label">市场情况</div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                </div>
                <div class="grid">

                  <div class="cell label">市场情况</div>
                  <div class="cell center">众多品牌</div>
                  <div class="cell center">众多品牌</div>
                  <div class="cell center">独家</div>
                  <div class="cell center">独家</div>
                </div>
              </section>

              <!-- ============ 面市时间 ============ -->
              <section id="time" class="block">
                <div class="block-title grid">
                  <div class="cell label">面市时间</div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                </div>
                <div class="grid">

                  <div class="cell label">面市时间</div>
                  <div class="cell center">2020年7月</div>
                  <div class="cell center">2019年4月</div>
                  <div class="cell center">2021年5月</div>
                  <div class="cell center">2025年8月</div>
                </div>
              </section>

              <!-- ============ 支持贴牌 ============ -->
              <section id="brand" class="block">
                <div class="block-title grid">
                  <div class="cell label">支持贴牌</div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                </div>
                <div class="grid">

                  <div class="cell label">是否支持</div>
                  <div class="cell center">支持</div>
                  <div class="cell center">不支持</div>
                  <div class="cell center">不支持</div>
                  <div class="cell center">不支持</div>
                </div>
              </section>

              <!-- ============ 运营扶持 ============ -->
              <section id="support" class="block">
                <div class="block-title grid">
                  <div class="cell label">运营扶持</div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                </div>
                <div class="grid">
                  <div class="cell label">二级子账户</div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>

                  <div class="cell label">推广商</div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>

                  <div class="cell label">区域独家</div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>
                  <div class="cell center"><img class="icon" src="../assets/no.png" alt="no" /></div>
                  <div class="cell center"><img class="icon" src="../assets/yes.png" alt="yes" /></div>
                </div>
              </section>
            </main>

            <!-- <main class="compare" style="margin-top: 50px;">
              <div class="grid tit-head" style=" background: #fff; box-sizing: border-box; ">
                <div class="cell cell-head">成本</div>
                <div class="cell cell-head">自助打印软件</div>
                <div class="cell cell-head">图文店自助打印软件</div>
                <div class="cell cell-head">复印机自助打印</div>
                <div class="cell cell-head">共享打印软件</div>
              </div>
              <section id="cost" class="block">
                <div class="block-title grid">
                  <div class="cell label">投放100台 各自成本多少？</div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                  <div class="cell center"></div>
                </div>
                <div class="grid">

                  <div class="cell label">打印机</div>
                  <div class="cell center">打印机 × 100</div>
                  <div class="cell center">打印机 × 100</div>
                  <div class="cell center">复印机 × 100</div>
                  <div class="cell center">打印机 × 100</div>

                  <div class="cell label">电脑/盒子</div>
                  <div class="cell center">盒子 × 100</div>
                  <div class="cell center">盒子 × 100</div>
                  <div class="cell center">0</div>
                  <div class="cell center">0</div>

                  <div class="cell label">软件</div>
                  <div class="cell center">￥6000</div>
                  <div class="cell center">不支持</div>
                  <div class="cell center">1000*100</div>
                  <div class="cell center">￥7200</div>
                </div>
              </section>
            </main> -->
          </div>
        </div>
        <!-- ----------- comp-wrap END ----------- -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeId: "main",
      sectionIds: [
        "main",
        "model",
        "install",
        "scene",
        "market",
        "time",
        "brand",
        "support",
        // "cost",
      ],
      labels: {
        main: "主要功能",
        model: "支持机型",
        install: "安装运行",
        scene: "应用场景",
        market: "市场情况",
        time: "面市时间",
        brand: "支持贴牌",
        support: "运营扶持",
        // cost: "成本",
      },
      rafId: null,
      onScrollHandler: null,
      isBtn: false,
      isBtnTimer: null,
    };
  },
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {
    // 立刻计算一次 active（页面加载时）
    this.computeActive();

    // 滚动监听，使用 rAF 节流
    this.onScrollHandler = () => {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(() => {
        this.computeActive();
      });
    };
    window.addEventListener("scroll", this.onScrollHandler, { passive: true });
    window.addEventListener("resize", this.onScrollHandler);
  },
  beforeDestroy() {
    if (this.rafId) cancelAnimationFrame(this.rafId);
    window.removeEventListener("scroll", this.onScrollHandler);
    window.removeEventListener("resize", this.onScrollHandler);
  },
  methods: {
    // 点击导航：带 header 补偿的平滑滚动
    scrollTo(id) {
      const el = this.$el.querySelector("#" + id);
      if (!el) return;
      const top = window.scrollY + el.getBoundingClientRect().top - 90;

      // 立即设置 active，避免点击后短时间内高亮错误
      this.activeId = id;

      window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: "smooth" });
      this.isBtn = true;
      clearTimeout(this.isBtnTimer);
      this.isBtnTimer = setTimeout(() => {
        this.isBtn = false;
      }, 1100);

      // 在少数浏览器中，smooth scroll 过程中 computeActive 也会同步更新
      // 所以我们不需要额外的定时器去修正，computeActive 会在滚动过程中被触发。
    },

    // 计算当前应该高亮的 section
    computeActive() {
      if (this.isBtn) {
        return
      }
      const sections = this.sectionIds
        .map((id) => this.$el.querySelector("#" + id))
        .filter(Boolean);

      if (!sections.length) return;
      // 我们认为“吸顶位置”是在视口顶部 
      const topOffset = 120;
      // 首先寻找所有 rect.top <= topOffset 的 section，取其中 rect.top 最大的（最靠近顶部）
      let candidate = null;
      let bestTop = -Infinity;
      sections.forEach((sec) => {
        const rect = sec.getBoundingClientRect();
        if (rect.top <= topOffset && rect.top > bestTop) {
          bestTop = rect.top;
          candidate = sec;
        }
      });

      // 如果没有任何 section 已经到达或越过吸顶线，选择视口内距离吸顶线最近的那个
      if (!candidate) {
        let minAbs = Infinity;
        sections.forEach((sec) => {
          const rect = sec.getBoundingClientRect();
          const abs = Math.abs(rect.top - topOffset);
          if (abs < minAbs) {
            minAbs = abs;
            candidate = sec;
          }
        });
      }

      if (candidate && candidate.id && this.activeId !== candidate.id) {
        this.activeId = candidate.id;
      }
    },
  },
};
</script>

<style lang="less" scoped>
/* 顶部 Banner */
.content {
  width: 100%;
  position: relative;
  background: no-repeat center center;
  background-size: cover;
}
.content-detail {
  position: absolute;
  top: 10rem;
  left: 15vw;
  h1 {
    font-size: 2.8rem;
    line-height: 2rem;
    color: #fff;
  }
  p {
    font-size: 1.75rem;
    color: #fff;
  }
}

.section-wrap {
  text-align: center;
  padding: 100px 0;
}
.title {
  margin-bottom: 30px;
}
.secd {
  margin: 4px 0;
}

/* ======= 对比主体 ======= */
.comparison-table {
  margin-top: 80px;
}

.comp-wrap {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 24px;
  align-items: start;
}

/* 左侧导航 */
.sidebar {
  position: sticky;
  top: -2px; /* 导航吸顶 */
  align-self: start;
  // height: calc(100vh - 40px);
  overflow: auto;
  padding: 16px;
  background: #f1f9ff;
  border: 2px solid #d3e4f1;

  a {
    display: block;
    text-align: left;
    padding: 10px 12px;
    margin-bottom: 6px;
    color: #333;
    text-decoration: none;
    outline: none !important;
    &.active {
      color: #3390ff;
    }
    &:focus {
      outline: none !important;
    }
  }
}

/* 右侧 */
.compare {
  width: 100%;
  border: 2px solid #d3e4f1;
}

/* 每个分组块 */
.block {
  scroll-margin-top: 12px; /* 点击锚点时，留出吸顶标题的空间 */
}

/* 分组标题：真正的“吸顶”元素 */
.block-title {
  position: sticky;
  top: 90px; /* 贴到视口顶端 */
  z-index: 5;
  text-align: left;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  background: #ffffffcc; /* 半透明，滚动时更柔和 */
  backdrop-filter: blur(2px);
  border-top: 1px solid #d3e4f1;
  &::after {
    position: absolute;
    left: 0;
    top: 0;
    content: "";
    display: block;
    height: 24px;
    width: 3px;
    background: #3390ff;
    margin: 12px 0;
  }
}

/* 网格“表格” */
.grid {
  display: grid;
  grid-template-columns: 180px repeat(4, 1fr);
}
.cell {
  padding: 12px 10px;
  text-align: left;
  &.center {
    text-align: center;
  }
}
.grid .cell:nth-child(4n) {
  /* 每行最后一个去掉右边框 */
  border-right: none;
}
.cell-head {
  font-weight: 600;
  background: #f1f9ff;
  text-align: center;
  height: 90px;
  line-height: 90px;
  padding: 0;
}
.label {
  background: #f1f9ff;
  padding-left: 30px;
}

/* 图标 */
.icon {
  width: 18px;
  height: 18px;
  vertical-align: -3px;
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Different.vue